import React, { useMemo, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useThemeMode } from '../contexts/ThemeContext';

// Ethereum Icon
const EthereumIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M16 0l-0.21 0.716v21.268l0.21 0.21 9.79-5.79z" opacity="0.6"/>
    <path d="M16 0l-9.79 16.404 9.79 5.79v-22.194z" opacity="0.45"/>
    <path d="M16 24.134l-0.118 0.144v7.516l0.118 0.206 9.796-13.798z" opacity="0.6"/>
    <path d="M16 32v-7.866l-9.79-5.932z" opacity="0.45"/>
    <path d="M16 22.194l9.79-5.79-9.79-4.456z" opacity="0.8"/>
    <path d="M6.21 16.404l9.79 5.79v-10.246z" opacity="0.6"/>
  </svg>
);

// Bitcoin Icon
const BitcoinIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M23.189 14.02c0.314-2.096-1.283-3.223-3.465-3.975l0.708-2.84-1.728-0.431-0.69 2.765c-0.454-0.113-0.92-0.22-1.385-0.326l0.695-2.783-1.728-0.431-0.708 2.839c-0.376-0.086-0.746-0.17-1.104-0.26l0.002-0.009-2.384-0.595-0.46 1.846s1.283 0.294 1.256 0.312c0.7 0.175 0.826 0.638 0.805 1.006l-0.806 3.235c0.048 0.012 0.11 0.03 0.18 0.057l-0.183-0.045-1.13 4.532c-0.086 0.212-0.303 0.531-0.793 0.41 0.017 0.025-1.256-0.314-1.256-0.314l-0.858 1.978 2.25 0.561c0.418 0.105 0.828 0.215 1.231 0.318l-0.715 2.872 1.727 0.431 0.708-2.84c0.472 0.127 0.93 0.245 1.378 0.357l-0.706 2.828 1.728 0.431 0.715-2.866c2.948 0.558 5.164 0.333 6.097-2.333 0.752-2.146-0.037-3.385-1.588-4.192 1.13-0.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-0.533 2.147-4.148 0.986-5.32 0.695l0.95-3.805c1.172 0.293 4.929 0.872 4.37 3.11zm0.535-5.569c-0.487 1.953-3.495 0.96-4.47 0.717l0.86-3.45c0.975 0.243 4.118 0.697 3.61 2.733z"/>
  </svg>
);

// Polygon/Matic Icon
const PolygonIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M21.092 12.693c-0.369-0.215-0.848-0.215-1.254 0l-2.879 1.654-1.955 1.078-2.879 1.654c-0.369 0.215-0.848 0.215-1.254 0l-2.288-1.294c-0.369-0.215-0.627-0.61-0.627-1.041v-2.479c0-0.431 0.221-0.826 0.627-1.041l2.251-1.258c0.369-0.215 0.848-0.215 1.254 0l2.251 1.258c0.369 0.215 0.627 0.61 0.627 1.041v1.654l1.955-1.114v-1.654c0-0.431-0.221-0.826-0.627-1.041l-4.17-2.372c-0.369-0.215-0.848-0.215-1.254 0l-4.244 2.408c-0.369 0.215-0.627 0.61-0.627 1.041v4.78c0 0.431 0.221 0.826 0.627 1.041l4.207 2.372c0.369 0.215 0.848 0.215 1.254 0l2.879-1.618 1.955-1.114 2.879-1.618c0.369-0.215 0.848-0.215 1.254 0l2.251 1.258c0.369 0.215 0.627 0.61 0.627 1.041v2.479c0 0.431-0.221 0.826-0.627 1.041l-2.214 1.294c-0.369 0.215-0.848 0.215-1.254 0l-2.251-1.258c-0.369-0.215-0.627-0.61-0.627-1.041v-1.618l-1.955 1.114v1.654c0 0.431 0.221 0.826 0.627 1.041l4.207 2.372c0.369 0.215 0.848 0.215 1.254 0l4.207-2.372c0.369-0.215 0.627-0.61 0.627-1.041v-4.78c0-0.431-0.221-0.826-0.627-1.041l-4.244-2.408z"/>
  </svg>
);

// Solana Icon
const SolanaIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M7.2 22.5c0.2-0.2 0.4-0.3 0.7-0.3h19.4c0.4 0 0.6 0.5 0.4 0.8l-3.5 3.5c-0.2 0.2-0.4 0.3-0.7 0.3H4.1c-0.4 0-0.6-0.5-0.4-0.8l3.5-3.5z" opacity="0.8"/>
    <path d="M7.2 5.5c0.2-0.2 0.5-0.3 0.7-0.3h19.4c0.4 0 0.6 0.5 0.4 0.8l-3.5 3.5c-0.2 0.2-0.4 0.3-0.7 0.3H4.1c-0.4 0-0.6-0.5-0.4-0.8l3.5-3.5z" opacity="0.6"/>
    <path d="M24.8 14c-0.2-0.2-0.4-0.3-0.7-0.3H4.7c-0.4 0-0.6 0.5-0.4 0.8l3.5 3.5c0.2 0.2 0.4 0.3 0.7 0.3h19.4c0.4 0 0.6-0.5 0.4-0.8L24.8 14z" opacity="0.7"/>
  </svg>
);

// Avalanche Icon
const AvalancheIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M20.4 21.6H25c0.6 0 0.9-0.2 1.1-0.7 0.2-0.5 0.1-0.9-0.3-1.4l-10-16.7c-0.4-0.6-0.7-0.7-1.2-0.7s-0.8 0.1-1.2 0.7L11 7.4c-0.3 0.5-0.3 1 0 1.5l9 12.1c0.3 0.4 0.6 0.6 1.1 0.6h-0.7z" opacity="0.7"/>
    <path d="M6 21.6h5.5c0.5 0 0.8-0.2 1.1-0.6l2.7-3.6c0.3-0.5 0.3-1 0-1.5L12 10.6c-0.3-0.5-0.7-0.7-1.2-0.7s-0.9 0.2-1.2 0.7L5 18.9c-0.4 0.7-0.4 1.2 0 1.7 0.2 0.7 0.5 1 1 1z" opacity="0.5"/>
  </svg>
);

// House/Property Icon
const PropertyIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M16 3L2 14h4v14h8v-8h4v8h8V14h4L16 3z" opacity="0.7"/>
    <rect x="12" y="14" width="3" height="3" opacity="0.5"/>
    <rect x="17" y="14" width="3" height="3" opacity="0.5"/>
  </svg>
);

// Building/Skyscraper Icon
const BuildingIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M4 28h24v2H4zM7 10h4v16H7zM13 4h6v22h-6zM21 8h4v18h-4z" opacity="0.6"/>
    <rect x="14" y="7" width="2" height="2" opacity="0.4"/>
    <rect x="14" y="11" width="2" height="2" opacity="0.4"/>
    <rect x="14" y="15" width="2" height="2" opacity="0.4"/>
    <rect x="14" y="19" width="2" height="2" opacity="0.4"/>
    <rect x="17" y="7" width="2" height="2" opacity="0.4"/>
    <rect x="17" y="11" width="2" height="2" opacity="0.4"/>
  </svg>
);

// Document/Invoice Icon
const DocumentIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M6 2h14l6 6v20c0 1.1-0.9 2-2 2H6c-1.1 0-2-0.9-2-2V4c0-1.1 0.9-2 2-2z" opacity="0.5"/>
    <path d="M20 2v6h6" opacity="0.3"/>
    <rect x="8" y="12" width="12" height="2" rx="0.5" opacity="0.6"/>
    <rect x="8" y="17" width="10" height="2" rx="0.5" opacity="0.6"/>
    <rect x="8" y="22" width="8" height="2" rx="0.5" opacity="0.6"/>
  </svg>
);

// Token/Coin Icon
const TokenIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <circle cx="16" cy="16" r="14" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4"/>
    <circle cx="16" cy="16" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3"/>
    <circle cx="16" cy="16" r="6" opacity="0.6"/>
    <path d="M16 10v12M12 14l4-4 4 4M12 18l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.8"/>
  </svg>
);

// Blockchain/Blocks Icon
const BlockchainIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <rect x="4" y="4" width="8" height="8" rx="1.5" opacity="0.5"/>
    <rect x="20" y="4" width="8" height="8" rx="1.5" opacity="0.5"/>
    <rect x="12" y="12" width="8" height="8" rx="1.5" opacity="0.7"/>
    <rect x="4" y="20" width="8" height="8" rx="1.5" opacity="0.5"/>
    <rect x="20" y="20" width="8" height="8" rx="1.5" opacity="0.5"/>
    <path d="M12 8h8M8 12v8M24 12v8M12 24h8" stroke="currentColor" strokeWidth="1" strokeDasharray="2,2" opacity="0.3"/>
  </svg>
);

// Chart/Growth Icon
const ChartIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <path d="M4 26l7-10 5 4 8-12 4 4" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
    <circle cx="11" cy="16" r="2.5" opacity="0.5"/>
    <circle cx="16" cy="20" r="2.5" opacity="0.5"/>
    <circle cx="24" cy="8" r="2.5" opacity="0.5"/>
    <circle cx="28" cy="12" r="2" opacity="0.4"/>
  </svg>
);

// Art/Collectible Icon
const ArtIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" width="100%" height="100%">
    <rect x="3" y="5" width="26" height="22" rx="2" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5"/>
    <circle cx="11" cy="13" r="3" opacity="0.6"/>
    <path d="M3 22l7-6 4 3 8-8 7 6" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5"/>
  </svg>
);

interface FloatingElement {
  id: number;
  icon: React.FC;
  size: number;
  x: number;
  y: number;
  duration: number;
  delay: number;
  opacity: number;
  rotation: number;
}

interface Sparkle {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
}

const Web3Background: React.FC = () => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const animationRef = useRef<number>();

  const icons = [
    EthereumIcon,
    BitcoinIcon,
    PolygonIcon,
    SolanaIcon,
    AvalancheIcon,
    PropertyIcon,
    BuildingIcon,
    DocumentIcon,
    TokenIcon,
    BlockchainIcon,
    ChartIcon,
    ArtIcon,
  ];

  // Generate floating elements
  const floatingElements = useMemo<FloatingElement[]>(() => {
    const elements: FloatingElement[] = [];
    const count = 22;

    for (let i = 0; i < count; i++) {
      elements.push({
        id: i,
        icon: icons[i % icons.length],
        size: 24 + Math.random() * 36,
        x: Math.random() * 100,
        y: Math.random() * 100,
        duration: 20 + Math.random() * 30,
        delay: Math.random() * -25,
        opacity: 0.04 + Math.random() * 0.08,
        rotation: Math.random() * 360,
      });
    }
    return elements;
  }, []);

  // Generate sparkles
  const sparkles = useMemo<Sparkle[]>(() => {
    const sparks: Sparkle[] = [];
    const count = 30;

    for (let i = 0; i < count; i++) {
      sparks.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: 2 + Math.random() * 4,
        duration: 3 + Math.random() * 4,
        delay: Math.random() * 5,
      });
    }
    return sparks;
  }, []);

  // Canvas particle effect
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Particle class
    interface Particle {
      x: number;
      y: number;
      vx: number;
      vy: number;
      size: number;
      opacity: number;
      pulsePhase: number;
    }

    const particles: Particle[] = [];
    const particleCount = 40;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        size: Math.random() * 2 + 0.5,
        opacity: Math.random() * 0.3 + 0.1,
        pulsePhase: Math.random() * Math.PI * 2,
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const time = Date.now() * 0.001;

      particles.forEach((particle, i) => {
        // Update position
        particle.x += particle.vx;
        particle.y += particle.vy;

        // Wrap around
        if (particle.x < 0) particle.x = canvas.width;
        if (particle.x > canvas.width) particle.x = 0;
        if (particle.y < 0) particle.y = canvas.height;
        if (particle.y > canvas.height) particle.y = 0;

        // Pulsing opacity
        const pulseOpacity = particle.opacity * (0.5 + 0.5 * Math.sin(time + particle.pulsePhase));

        // Draw particle with glow
        const gradient = ctx.createRadialGradient(
          particle.x, particle.y, 0,
          particle.x, particle.y, particle.size * 3
        );

        const color = isDark ? '59, 130, 246' : '30, 64, 175';
        gradient.addColorStop(0, `rgba(${color}, ${pulseOpacity})`);
        gradient.addColorStop(0.5, `rgba(${color}, ${pulseOpacity * 0.3})`);
        gradient.addColorStop(1, `rgba(${color}, 0)`);

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size * 3, 0, Math.PI * 2);
        ctx.fillStyle = gradient;
        ctx.fill();

        // Draw connections to nearby particles
        particles.slice(i + 1).forEach((p2) => {
          const dx = particle.x - p2.x;
          const dy = particle.y - p2.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 120) {
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(p2.x, p2.y);
            const connectionOpacity = isDark ? 0.06 : 0.04;
            ctx.strokeStyle = `rgba(${color}, ${connectionOpacity * (1 - distance / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        });
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isDark]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    >
      {/* Canvas for particle system */}
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />

      {/* Gradient overlays */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: isDark
            ? 'radial-gradient(ellipse at 15% 15%, rgba(30, 64, 175, 0.12) 0%, transparent 45%), radial-gradient(ellipse at 85% 85%, rgba(14, 165, 233, 0.08) 0%, transparent 45%), radial-gradient(ellipse at 50% 50%, rgba(99, 102, 241, 0.05) 0%, transparent 60%)'
            : 'radial-gradient(ellipse at 15% 15%, rgba(30, 64, 175, 0.06) 0%, transparent 45%), radial-gradient(ellipse at 85% 85%, rgba(14, 165, 233, 0.04) 0%, transparent 45%)',
        }}
      />

      {/* Subtle grid */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: isDark
            ? `linear-gradient(rgba(59, 130, 246, 0.025) 1px, transparent 1px),
               linear-gradient(90deg, rgba(59, 130, 246, 0.025) 1px, transparent 1px)`
            : `linear-gradient(rgba(30, 64, 175, 0.015) 1px, transparent 1px),
               linear-gradient(90deg, rgba(30, 64, 175, 0.015) 1px, transparent 1px)`,
          backgroundSize: '80px 80px',
        }}
      />

      {/* Floating Web3/RWA icons */}
      {floatingElements.map((element) => {
        const IconComponent = element.icon;
        const animationType = element.id % 5;

        return (
          <Box
            key={element.id}
            sx={{
              position: 'absolute',
              left: `${element.x}%`,
              top: `${element.y}%`,
              width: element.size,
              height: element.size,
              color: isDark ? 'rgba(96, 165, 250, 1)' : 'rgba(30, 64, 175, 1)',
              opacity: element.opacity,
              transform: `rotate(${element.rotation}deg)`,
              animation: `web3-float-${animationType} ${element.duration}s ease-in-out infinite`,
              animationDelay: `${element.delay}s`,
              filter: isDark ? 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.3))' : 'none',
              '@keyframes web3-float-0': {
                '0%, 100%': { transform: `rotate(${element.rotation}deg) translateY(0) translateX(0)` },
                '25%': { transform: `rotate(${element.rotation + 8}deg) translateY(-25px) translateX(15px)` },
                '50%': { transform: `rotate(${element.rotation}deg) translateY(-15px) translateX(-10px)` },
                '75%': { transform: `rotate(${element.rotation - 8}deg) translateY(-30px) translateX(-15px)` },
              },
              '@keyframes web3-float-1': {
                '0%, 100%': { transform: `rotate(${element.rotation}deg) translateY(0) scale(1)` },
                '50%': { transform: `rotate(${element.rotation + 15}deg) translateY(-35px) scale(1.15)` },
              },
              '@keyframes web3-float-2': {
                '0%, 100%': { transform: `rotate(${element.rotation}deg) translate(0, 0)` },
                '33%': { transform: `rotate(${element.rotation + 10}deg) translate(20px, -15px)` },
                '66%': { transform: `rotate(${element.rotation - 10}deg) translate(-20px, -25px)` },
              },
              '@keyframes web3-float-3': {
                '0%, 100%': { transform: `rotate(${element.rotation}deg) translateY(0)`, opacity: element.opacity },
                '50%': { transform: `rotate(${element.rotation + 20}deg) translateY(-40px)`, opacity: element.opacity * 1.8 },
              },
              '@keyframes web3-float-4': {
                '0%': { transform: `rotate(${element.rotation}deg) translateY(0) translateX(0)` },
                '20%': { transform: `rotate(${element.rotation + 5}deg) translateY(-10px) translateX(10px)` },
                '40%': { transform: `rotate(${element.rotation}deg) translateY(-20px) translateX(5px)` },
                '60%': { transform: `rotate(${element.rotation - 5}deg) translateY(-15px) translateX(-5px)` },
                '80%': { transform: `rotate(${element.rotation}deg) translateY(-5px) translateX(-10px)` },
                '100%': { transform: `rotate(${element.rotation}deg) translateY(0) translateX(0)` },
              },
            }}
          >
            <IconComponent />
          </Box>
        );
      })}

      {/* Sparkle effects */}
      {sparkles.map((sparkle) => (
        <Box
          key={`sparkle-${sparkle.id}`}
          sx={{
            position: 'absolute',
            left: `${sparkle.x}%`,
            top: `${sparkle.y}%`,
            width: sparkle.size,
            height: sparkle.size,
            borderRadius: '50%',
            background: isDark
              ? 'radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, rgba(147, 197, 253, 0.4) 50%, transparent 70%)'
              : 'radial-gradient(circle, rgba(59, 130, 246, 0.6) 0%, rgba(30, 64, 175, 0.2) 50%, transparent 70%)',
            animation: `sparkle ${sparkle.duration}s ease-in-out infinite`,
            animationDelay: `${sparkle.delay}s`,
            '@keyframes sparkle': {
              '0%, 100%': { opacity: 0, transform: 'scale(0.5)' },
              '50%': { opacity: 1, transform: 'scale(1.2)' },
            },
          }}
        />
      ))}

      {/* Animated connection lines SVG */}
      <svg
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          opacity: isDark ? 0.05 : 0.03,
        }}
      >
        <defs>
          <linearGradient id="web3LineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="50%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#0EA5E9" />
          </linearGradient>
        </defs>

        {/* Network lines */}
        <path
          d="M5,20 Q30,10 50,30 T95,25"
          fill="none"
          stroke="url(#web3LineGradient)"
          strokeWidth="1.5"
          strokeDasharray="8,12"
          style={{ animation: 'dashMove 30s linear infinite' }}
        />
        <path
          d="M10,70 Q35,50 55,65 T90,55"
          fill="none"
          stroke="url(#web3LineGradient)"
          strokeWidth="1.5"
          strokeDasharray="8,12"
          style={{ animation: 'dashMove 25s linear infinite', animationDelay: '-10s' }}
        />
        <path
          d="M15,45 C30,30 70,60 85,40"
          fill="none"
          stroke="url(#web3LineGradient)"
          strokeWidth="1"
          strokeDasharray="5,10"
          style={{ animation: 'dashMove 35s linear infinite', animationDelay: '-5s' }}
        />
        <path
          d="M20,85 Q45,70 65,80 T95,75"
          fill="none"
          stroke="url(#web3LineGradient)"
          strokeWidth="1"
          strokeDasharray="6,8"
          style={{ animation: 'dashMove 28s linear infinite', animationDelay: '-15s' }}
        />

        <style>
          {`
            @keyframes dashMove {
              to { stroke-dashoffset: -200; }
            }
          `}
        </style>
      </svg>

      {/* Glowing orbs */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '8%',
          width: 350,
          height: 350,
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(59, 130, 246, 0.12) 0%, transparent 65%)'
            : 'radial-gradient(circle, rgba(59, 130, 246, 0.06) 0%, transparent 65%)',
          filter: 'blur(50px)',
          animation: 'orbPulse 10s ease-in-out infinite',
          '@keyframes orbPulse': {
            '0%, 100%': { transform: 'scale(1)', opacity: 0.6 },
            '50%': { transform: 'scale(1.25)', opacity: 0.9 },
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '15%',
          right: '10%',
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(14, 165, 233, 0.1) 0%, transparent 65%)'
            : 'radial-gradient(circle, rgba(14, 165, 233, 0.05) 0%, transparent 65%)',
          filter: 'blur(50px)',
          animation: 'orbPulse 12s ease-in-out infinite',
          animationDelay: '-5s',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '45%',
          left: '45%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(139, 92, 246, 0.06) 0%, transparent 60%)'
            : 'radial-gradient(circle, rgba(99, 102, 241, 0.03) 0%, transparent 60%)',
          filter: 'blur(70px)',
          animation: 'orbPulse 15s ease-in-out infinite',
          animationDelay: '-3s',
        }}
      />

      {/* Hexagon pattern overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: isDark ? 0.025 : 0.015,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%233B82F6' fill-rule='nonzero'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
    </Box>
  );
};

export default Web3Background;
